export default __webpack_public_path__ + "static/media/viewavatar.0dfca0fa.svg";